import { z } from "zod";
import { type RemoteName } from "../../../mfe/mfeConfig";
import { loadMFE } from "../../../mfe/mfeLoaders";

export const vendorConfigPluginZod = z.object({
  getByKey: z
    .function()
    .args(z.string())
    .returns(
      z.union([z.string(), z.boolean(), z.record(z.string()), z.undefined()])
    ),
  isBrandMM: z.function().returns(z.boolean()),
  isBrandDirectSMS: z.function().returns(z.boolean()),
  isBrandMessageNet: z.function().returns(z.boolean()),
  isBrandMobiPost: z.function().returns(z.boolean()),
  isBrandStreetData: z.function().returns(z.boolean()),
  isBrandTPG: z.function().returns(z.boolean()),
  isBrandSMSC: z.function().returns(z.boolean()),
  isBrandSMSB: z.function().returns(z.boolean()),
  isBrandWholeSale: z.function().returns(z.boolean()),
  isBrandSimpleTexting: z.function().returns(z.boolean()),
  isNZCarriers: z.function().returns(z.boolean()),
  isBrandMS: z.function().returns(z.boolean()),
  isBrandSE: z.function().returns(z.boolean()),
});

export type VendorConfigPlugin =
  | z.infer<typeof vendorConfigPluginZod>
  | undefined;

export const loadVendorConfigPlugin = async (
  scope: RemoteName,
  module: string
): Promise<VendorConfigPlugin> => {
  const mfe = await loadMFE(scope, module);
  const plugin = mfe as unknown as Record<string, unknown>;
  const parsed = vendorConfigPluginZod.safeParse(plugin);
  if (parsed.success) {
    return parsed.data;
  }
  console.error(
    `${loadVendorConfigPlugin.name}: Vendor Config interface has changed, contact mmgp-frontend team for more information`,
    parsed.error
  );
  throw new Error(loadVendorConfigPlugin.name + "Error");
};
